import { deserialize, Http, HttpConfig, HttpError } from '@ezio/http'

import { createEventHook } from '@vueuse/core'
import { underscoreKeysToCamelCase } from '@ezio/utils'

const loggingOut = createEventHook<any>()

class API extends Http {
    public tokensStore = null

    public constructor(config: HttpConfig) {
        super()
        this.config = config
    }

    protected getRequestHeaders() {
        const headers = {
            Accept: 'application/json',
            'Cache-Control': 'no-store no-cache must-revalidate',
            Authorization: 'Bearer ' + this.tokensStore.token
        }
        return headers
    }

    protected async onSuccess(response: any) {
        this.tokensStore.storeNodeAPIToken(response.headers)
        if (response.data.cursor) {
            return response
        }
        const r: any = {
            data: await deserialize(response.data),
            meta: underscoreKeysToCamelCase(response.data.meta)
        }

        return r
    }

    protected onError(error: HttpError): HttpError {
        if (error.status === 401 || error.status === 403) {
            console.warn('401/403 : logging out')

            this.tokensStore.reset()

            loggingOut.trigger(error.message)
        }

        return super.onError(error)
    }

    public onLoggingOut(params: any) {
        return loggingOut.on(params)
    }
}

let api: API = null

const init = (config: HttpConfig) => {
    api = new API(config)
    return api
}

export const useEzioNodeAPI = () => {
    return {
        api,
        init
    }
}
